import React from "react";
import { XSProvider } from "@ww-digital/xs-sdk-react";
import GUA from "@ww-digital/xs-plugin-gua";
import { getCookieValue } from "../../utils/cookies";

const gua = new GUA();

export default function AppXSProvider({ children }) {
  let visitorId = getCookieValue("ww_browser_id");

  return (
    <XSProvider
      user={{
        visitorId: visitorId || "",
        locale: window.ww.locale
      }}
      baseUrl={window.ww.xsBaseUrl}
      plugins={[gua]}
      context={{
        locale: window.ww.locale,
        app: "ww_vs",
        team: "wpf"
      }}
    >
      {children}
    </XSProvider>
  );
}
